import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { field, table } from '@tencent/memoire-structured-storage';
import BlobConverter, { BlobEncoding } from '../utils/blob-converter';
import PathUtils from '../utils/path-utils';
import BlobBaseModel from './blob-base-model';
var BlobDataModel = /** @class */ (function (_super) {
    __extends(BlobDataModel, _super);
    function BlobDataModel(_a) {
        var path = _a.path, namespace = _a.namespace, data = _a.data, type = _a.type;
        var _this = _super.call(this, { path: path, namespace: namespace, type: type }) || this;
        _this.data = data;
        return _this;
    }
    BlobDataModel.fromBlob = function (path, blob) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.bind;
                        _b = {
                            namespace: PathUtils.namespace(path),
                            path: PathUtils.normalize(path)
                        };
                        return [4 /*yield*/, BlobConverter.convertBlob(blob, BlobEncoding.ArrayBuffer)];
                    case 1: return [2 /*return*/, new (_a.apply(this, [void 0, (_b.data = _c.sent(),
                                _b.type = blob.type,
                                _b)]))()];
                }
            });
        });
    };
    __decorate([
        field()
    ], BlobDataModel.prototype, "data", void 0);
    BlobDataModel = __decorate([
        table('BlobData')
    ], BlobDataModel);
    return BlobDataModel;
}(BlobBaseModel));
export default BlobDataModel;
//# sourceMappingURL=blob-data-model.js.map